import type { MeterEventEntity, MeterEventType, SerializedMeterEvent } from '@enmon/commons/lib/tools';
import { buildQuery } from '@enmon/commons/lib/tools/utils/buildQuery';
import { BASE_REST_API_URL } from 'common';
import { BaseApiClient } from './baseApiClient';

export interface MeterEventsFilter {
  entity?: MeterEventEntity;
  type?: MeterEventType;
  page?: number;
  pageSize?: number;
  backendGatewayMeterId?: string | number;
  inventoryMeterId?: string | number;
  sort?: Record<string, 'asc' | 'desc'>;
}

export interface MeterEventsMeta {
  pagination: {
    page: number;
    pageSize: number;
    pageCount: number;
    total: number;
  };
}

export interface MeterEventsResult {
  data: SerializedMeterEvent[];
  meta: MeterEventsMeta;
}

export interface IMeterEventsApiClient {
  find: (filter: MeterEventsFilter, signal?: AbortSignal) => Promise<MeterEventsResult>;
}

export class MeterEventsApiClient extends BaseApiClient implements IMeterEventsApiClient {
  constructor(jwt: string) {
    super('meter-events', BASE_REST_API_URL, jwt);
  }

  public async find(filter: MeterEventsFilter, signal?: AbortSignal): Promise<MeterEventsResult> {
    const { entity, type, page, pageSize, backendGatewayMeterId, inventoryMeterId, sort } = filter;
    const response = await this.axios.get<MeterEventsResult>('', {
      params: buildQuery<any>({
        filters: {
          ...(entity && { entity: { $eq: entity } }),
          ...(type && { type: { $eq: type } }),
          ...(backendGatewayMeterId && { backend_gateway_meter_id: { $eq: backendGatewayMeterId } }),
          ...(inventoryMeterId && { inventory_meter: { $eq: inventoryMeterId } }),
        },
        populate: ['submitted_by', 'inventory_meter'],
        ...(sort && { sort }),
        ...(page &&
          pageSize && {
            pagination: {
              page,
              pageSize,
            },
          }),
      }),
      signal,
    });

    return response.data;
  }
}
